var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "commonInfo-box" }, [
      _c("div", { staticClass: "commonInfo-title" }, [
        _c("div", { staticClass: "title-des" }, [
          _vm._v(_vm._s(_vm.title || "基本信息")),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "title-switch",
          class: _vm.switchState ? "" : "close",
          on: { click: function ($event) {} },
        }),
      ]),
      _vm._v(" "),
      _vm.switchState
        ? _c("div", { staticClass: "commonInfo-list" }, [
            _c(
              "div",
              { staticClass: "commonInfo-item" },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-width": "160px",
                      rules: _vm.rules,
                      model: _vm.data,
                    },
                  },
                  _vm._l(_vm.fieldList, function (item) {
                    return _c(
                      "el-form-item",
                      {
                        key: item.value,
                        attrs: { label: item.label || "", prop: item.value },
                      },
                      [
                        item.type === "input"
                          ? _c("el-input", {
                              attrs: {
                                type: item.inputType,
                                clearable: "",
                                disabled: item.disabled,
                                placeholder: _vm.getPlaceholder(item),
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.handleEvent(item)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "number"
                          ? _c("el-input", {
                              attrs: {
                                onKeyUp: "value=value.replace(/[^0-9.]/g,'')",
                                clearable: "",
                                disabled: item.disabled,
                                placeholder: _vm.getPlaceholder(item),
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.handleEvent(item)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "textarea"
                          ? _c("el-input", {
                              attrs: {
                                type: item.type,
                                maxlength: item.maxlength,
                                "show-word-limit": "",
                                clearable: "",
                                disabled: item.disabled,
                                placeholder: _vm.getPlaceholder(item),
                                autosize: item.autosize || {
                                  minRows: 3,
                                  maxRows: 10,
                                },
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.handleEvent(item)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.data,
                                    item.value,
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "inputNumber"
                          ? _c("el-input-number", {
                              attrs: {
                                disabled: item.disabled,
                                size: "small",
                                min: item.min,
                                max: item.max,
                                "controls-position": "right",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(item)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "select"
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: item.disabled,
                                  clearable: "",
                                  filterable: item.filterable,
                                  placeholder: _vm.getPlaceholder(item),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleEvent(
                                      item,
                                      $event,
                                      _vm.data[item.value]
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.data[item.value],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, item.value, $$v)
                                  },
                                  expression: "data[item.value]",
                                },
                              },
                              _vm._l(item.options, function (item2, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.porpLabel
                                      ? item2[item.porpLabel]
                                      : item2.label,
                                    value: item.porpValue
                                      ? item2[item.porpValue]
                                      : item2.value,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "select2"
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: item.disabled,
                                  clearable: "",
                                  placeholder: _vm.getPlaceholder(item),
                                  filterable: "",
                                  remote: "",
                                  "remote-method": function (query) {
                                    _vm.remoteMethod(query, item)
                                  },
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleEvent(
                                      item,
                                      $event,
                                      _vm.data[item.value]
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.data[item.value],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, item.value, $$v)
                                  },
                                  expression: "data[item.value]",
                                },
                              },
                              _vm._l(item.options, function (item2, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.porpLabel
                                      ? item2[item.porpLabel]
                                      : item2.label,
                                    value: item.porpValue
                                      ? item2[item.porpValue]
                                      : item2.value,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "radio"
                          ? _c(
                              "el-radio-group",
                              {
                                attrs: {
                                  disabled: item.disabled,
                                  placeholder: _vm.getPlaceholder(item),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleEvent(
                                      item,
                                      _vm.data[item.value]
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.data[item.value],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, item.value, $$v)
                                  },
                                  expression: "data[item.value]",
                                },
                              },
                              _vm._l(
                                item.options,
                                function (childItem, childIndex) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      key: childIndex,
                                      attrs: { label: childItem.value },
                                    },
                                    [_vm._v(_vm._s(childItem.label))]
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "check"
                          ? _c(
                              "el-checkbox-group",
                              {
                                attrs: { disabled: item.disabled },
                                model: {
                                  value: _vm.data[item.value],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, item.value, $$v)
                                  },
                                  expression: "data[item.value]",
                                },
                              },
                              _vm._l(item.options, function (item2) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item2.value,
                                    attrs: { label: item2.value },
                                  },
                                  [_vm._v(_vm._s(item2.label))]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "date"
                          ? _c("el-date-picker", {
                              attrs: {
                                type: item.dateType,
                                "picker-options":
                                  _vm.datePickerOptions[item.pickerOptions],
                                clearable: "",
                                disabled: item.disabled,
                                "default-time": item.defaultTime,
                                placeholder: _vm.getPlaceholder(item),
                                "start-placeholder": "请选择开始日期",
                                "end-placeholder": "请选择结束日期",
                                "value-format": "yyyy-MM-dd",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.handleEvent(item)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "city"
                          ? _c("el-cascader", {
                              attrs: {
                                disabled: item.disabled,
                                options: _vm.cityInfo,
                                props: _vm.cityProps,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(item, $event)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "city2"
                          ? _c("el-cascader", {
                              attrs: {
                                disabled: item.disabled,
                                options: _vm.cityInfo3,
                                props: _vm.cityProps,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(item, $event)
                                },
                              },
                              model: {
                                value: _vm.data[item.value],
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, item.value, $$v)
                                },
                                expression: "data[item.value]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "title"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "16px",
                                },
                              },
                              [_vm._v(_vm._s(item.titleLabel))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "word"
                          ? _c("div", [_vm._v(_vm._s(item.word))])
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "upload"
                          ? _c(
                              "el-upload",
                              {
                                attrs: {
                                  action:
                                    "http://118.31.52.107:8521/api/upload-local",
                                  "on-success": _vm.handleSuccess,
                                  multiple: "",
                                  "file-list": _vm.data[item.value],
                                },
                              },
                              [
                                _vm.orderType != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.choiceItem = item
                                          },
                                        },
                                      },
                                      [_vm._v("点击上传")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "table"
                          ? [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: item.tableData,
                                    border: "",
                                    "row-class-name": _vm.tableRowClassName,
                                  },
                                },
                                [
                                  _vm._l(
                                    item.tableOption,
                                    function (item2, index) {
                                      return _c("el-table-column", {
                                        key: index,
                                        attrs: { label: item2.label },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "header",
                                              fn: function (scope) {
                                                return [
                                                  item2.tag
                                                    ? _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "common-tag",
                                                        },
                                                        [_vm._v("*")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(item2.label) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.orderType != 1
                                                    ? [
                                                        item2.type == "input"
                                                          ? _c("el-input", {
                                                              attrs: {
                                                                placeholder:
                                                                  _vm.getPlaceholder(
                                                                    item2
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row[
                                                                    item2.key
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      item2.key,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row[item2.key]",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item2.type === "select"
                                                          ? _c(
                                                              "el-select",
                                                              {
                                                                attrs: {
                                                                  clearable: "",
                                                                  placeholder:
                                                                    _vm.getPlaceholder(
                                                                      item2
                                                                    ),
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row[
                                                                      item2.key
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        item2.key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row[item2.key]",
                                                                },
                                                              },
                                                              _vm._l(
                                                                item2.options,
                                                                function (
                                                                  item3,
                                                                  index2
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: index2,
                                                                      attrs: {
                                                                        label:
                                                                          item.porpLabel
                                                                            ? item3[
                                                                                item
                                                                                  .porpLabel
                                                                              ]
                                                                            : item3.label,
                                                                        value:
                                                                          item.porpValue
                                                                            ? item3[
                                                                                item
                                                                                  .porpValue
                                                                              ]
                                                                            : item3.value,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item2.type === "select2"
                                                          ? _c(
                                                              "el-select",
                                                              {
                                                                attrs: {
                                                                  clearable: "",
                                                                  placeholder:
                                                                    _vm.getPlaceholder(
                                                                      item2
                                                                    ),
                                                                  filterable:
                                                                    "",
                                                                  remote: "",
                                                                  "remote-method":
                                                                    function (
                                                                      query
                                                                    ) {
                                                                      _vm.remoteMethod(
                                                                        query,
                                                                        scope.row
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row[
                                                                      item2.key
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        item2.key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row[item2.key]",
                                                                },
                                                              },
                                                              _vm._l(
                                                                item2.options,
                                                                function (
                                                                  item3,
                                                                  index2
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: index2,
                                                                      attrs: {
                                                                        label:
                                                                          item.porpLabel
                                                                            ? item3[
                                                                                item
                                                                                  .porpLabel
                                                                              ]
                                                                            : item3.code,
                                                                        value:
                                                                          item.porpValue
                                                                            ? item3[
                                                                                item
                                                                                  .porpValue
                                                                              ]
                                                                            : item3.code,
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item2.type === "date"
                                                          ? _c(
                                                              "el-date-picker",
                                                              {
                                                                attrs: {
                                                                  type: item2.dateType,
                                                                  "picker-options":
                                                                    _vm
                                                                      .datePickerOptions[
                                                                      item2
                                                                        .pickerOptions
                                                                    ],
                                                                  clearable: "",
                                                                  disabled:
                                                                    item2.disabled,
                                                                  "default-time":
                                                                    item2.defaultTime,
                                                                  placeholder:
                                                                    _vm.getPlaceholder(
                                                                      item
                                                                    ),
                                                                  "start-placeholder":
                                                                    "请选择开始日期",
                                                                  "end-placeholder":
                                                                    "请选择结束日期",
                                                                  "value-format":
                                                                    "yyyy-MM-dd",
                                                                },
                                                                on: {
                                                                  focus:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleEvent(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row[
                                                                      item2.key
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        item2.key,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row[item2.key]",
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item2.type === "number"
                                                          ? _c("el-input", {
                                                              attrs: {
                                                                onKeyUp:
                                                                  "value=value.replace(/[^0-9.]/g,'')",
                                                                clearable: "",
                                                                disabled:
                                                                  item2.disabled,
                                                                placeholder:
                                                                  _vm.getPlaceholder(
                                                                    item2
                                                                  ),
                                                              },
                                                              on: {
                                                                focus:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleEvent(
                                                                      item2
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  scope.row[
                                                                    item2.key
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      item2.key,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "scope.row[item2.key]",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row[
                                                                item2.key
                                                              ]
                                                            )
                                                          ),
                                                        ]),
                                                      ],
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "100" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "small" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.del(
                                                        scope.row,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.orderType != 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { plain: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addTable(item)
                                        },
                                      },
                                    },
                                    [_vm._v("添加")]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _vm.orderType != 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm", 1)
                    },
                  },
                },
                [_vm._v("提交备案")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.orderType != 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm", 0)
                    },
                  },
                },
                [_vm._v("暂存草稿")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }